module.exports = __webpack_public_path__ + "img/ring_r_s_1_null@3x.394da5e0.png";